export default class MongoLocation {
  address = "";
  city = "";
  countryCode = "";
  countryName = "";
  postalCode = "";
  latitude = 0;
  longitude = 0;
}
